module.exports = __webpack_public_path__ + "img/mng.9ebe47eb.svg";